import React, { useCallback, useMemo } from 'react'
import { Button, Flex, Typography } from 'antd'
import { CloseOutlined, MessageOutlined, RightOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import styles from './styles.module.scss'

const { Text } = Typography

const HIGHLIGHT_PATTERNS = ['Gratis!!']

const GreenMessage = ({ id, title, content, buttonText, onClose, onClick }) => {
  const { formatMessage } = useIntl()

  const handleClose = useCallback(
    (e) => {
      e?.stopPropagation()
      onClose?.(id)
    },
    [id, onClose],
  )

  const handleClick = useCallback(
    (e) => {
      e?.stopPropagation()
      onClick?.(id)
    },
    [id, onClick],
  )

  const renderContent = useMemo(() => {
    if (!content) {
      return null
    }
    const pattern = HIGHLIGHT_PATTERNS.find((p) => content.includes(p))
    if (!pattern) {
      return <span>{content}</span>
    }
    const parts = content.split(pattern)
    return (
      <>
        {parts[0]}
        <span className={styles.highlight}>{pattern}</span>
        {parts[1] || ''}
      </>
    )
  }, [content])

  return (
    <div className={styles.banner}>
      <button
        type="button"
        className={styles.closeButtonMobile}
        onClick={handleClose}
        aria-label="Tutup"
      >
        <CloseOutlined />
      </button>
      <Flex align="center" justify="space-between" gap={20} className={styles.content}>
        <Flex
          align="flex-start"
          gap={16}
          flex={1}
          className={styles.textSection}
          style={{ minWidth: 0 }}
        >
          <div className={styles.iconWrapper}>
            <MessageOutlined className={styles.icon} />
          </div>
          <Flex vertical gap={5} style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
            <Flex align="center" gap={10} wrap="wrap" className={styles.headerRow}>
              <div className={styles.iconWrapperMobile}>
                <MessageOutlined className={styles.iconMobile} />
              </div>
              <span className={styles.badge}>{formatMessage({ id: 'new_badge_text' })}</span>
              <Text strong className={styles.title}>
                {title}
              </Text>
            </Flex>
            <Text className={styles.description}>{renderContent}</Text>
          </Flex>
        </Flex>
        <Flex align="center" gap={14} className={styles.actions}>
          <button
            type="button"
            className={styles.closeButtonDesktop}
            onClick={handleClose}
            aria-label="Tutup"
          >
            <CloseOutlined />
          </button>
          <Button
            type="primary"
            className={styles.ctaButton}
            onClick={handleClick}
            icon={<RightOutlined />}
            iconPosition="end"
          >
            {buttonText}
          </Button>
        </Flex>
      </Flex>
    </div>
  )
}

export default GreenMessage
